<ng-container *ngIf="(page.step$ | async) === 1">
  <div *ngIf="page.profile$ | async as profile" class="progress-container">
    <ng-container *ngIf="!profile.completed">
      <div class="progress-text">
        <h1>
          {{ 'resources.greeting' | translate: { name: profile.firstName } }}
        </h1>
        <p>{{ 'resources.profile_incomplete' | translate }}</p>
      </div>
      <app-button
        [title]="'resources.back_to_profile' | translate"
        routerLink="/profile"
      ></app-button>
    </ng-container>
    <ng-container *ngIf="profile.completed">
      <div class="progress-text">
        <h1>
          {{ 'resources.greeting' | translate: { name: profile.firstName } }}
        </h1>
        <p>{{ 'resources.join_or_create_group' | translate }}</p>
      </div>
      <app-button
        [title]="'resources.back_to_group' | translate"
        routerLink="/profile/company"
      ></app-button>
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="(page.step$ | async) === 2">
  <div class="progress-container">
    <div class="progress-text">
      <h1>{{ 'resources.ready_to_fly' | translate }}</h1>
      <p *ngIf="page.company$ | async; let company">
        {{ 'resources.ready_message' | translate: { company: company.name } }}
      </p>
    </div>
    <app-progress-bar></app-progress-bar>
    <app-button
      (click)="page.goToAddDevice()"
      [title]="'resources.add_first_drone' | translate"
    ></app-button>
  </div>
</ng-container>

<ng-container *ngIf="(page.step$ | async) === 3">
  <app-header [title]="'resources.title' | translate">
    @if (page.isAddResourceEnabled$ | async) {
      <app-button
        testId="resources-add-device"
        (click)="page.goToAddDevice()"
        [black]="true"
        [title]="'resources.add_device' | translate"
        class="flex-position-end"
        header-button
      >
      </app-button>
    }
  </app-header>
  <mat-tab-group>
    <mat-tab label="{{ 'resources.devices' | translate }}">
      <ng-template matTabContent>
        <app-device-table></app-device-table>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="resources-tab-parts">
          {{ 'resources.parts' | translate }}
        </span>
      </ng-template>
      <ng-template matTabContent>
        <app-part-list-table></app-part-list-table>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</ng-container>
